import ModalEditar from "./modalEditar";

export default ModalEditar;